import { Component, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { faTrashAlt, faPencilAlt, faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { ToastrService } from 'ngx-toastr';

import { ExamTemplate } from '../exam-template';
import { ExamTemplateService } from '../../service/exam-template.service';

declare var jQuery: any;

@Component({
  selector: 'mc-exam-template-list',
  templateUrl: './exam-template-list.component.html'
})
export class ExamTemplateListComponent {

  trashAlt = faTrashAlt;
  pencilAlt = faPencilAlt;
  plusCircle = faPlusCircle;

  @ViewChild('deleteTemplateModal', { static: true }) private deleteTemplateModal: ElementRef;
  @Input() public templates: ExamTemplate[];
  @Input() public crudMode: boolean = true;
  @Output() selected: EventEmitter<ExamTemplate> = new EventEmitter<ExamTemplate>();
  examTemplateToDelete: ExamTemplate = new ExamTemplate();

  constructor(
    private examTemplateService: ExamTemplateService,
    private notifService: ToastrService
  ) {}

  select(template: ExamTemplate): void {
    this.selected.emit(template);
  }

  confirmDelete(examTemplate: ExamTemplate): void {
    this.examTemplateToDelete = examTemplate;
    jQuery(this.deleteTemplateModal.nativeElement).modal('show');
  }

  deleteExamTemplate(): void {
    const id = this.examTemplateToDelete.id;
    this.examTemplateService.delete(id).subscribe(
      success => {
        const index = this.templates.findIndex(el => el.id == id);
        this.templates.splice(index, 1);
        this.notifService.success('Procedimento excluido');
      },
      error => this.notifService.error(error)
    );
  }
}
